/**
 * 下半分の上端の情報帯（Issue #467）。1 行目は core で起きたこと（応答のあとに増えたイベントを TICKER_MS ずつ。流し終えたら最後の文を薄く残す）、
 * 2 行目は今の時刻の発話（話者名つき。同時に喋っていれば / で並べる）。**高さは固定**で、文字が出たり消えたりしても下の操作が動かない。
 */
export const INFO_STRIP_H = 48;

export default function InfoStrip({ ticker = null, lastText = null, subtitles = [] }) {
  const line = { height: 22, lineHeight: '22px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 13 };
  const eventText = ticker?.text ?? lastText;
  return (
    <div data-testid="info-strip" style={{ height: INFO_STRIP_H, flexShrink: 0, boxSizing: 'border-box', padding: '2px 10px', borderBottom: '1px solid #1c2440', background: '#0c1222' }}>
      <div data-testid="info-event" data-live={ticker ? '1' : undefined} role="status" style={{ ...line, fontWeight: ticker ? 800 : 400, color: ticker ? '#fff' : '#8896b3' }}>
        <span aria-hidden style={{ color: '#4fc3ff', marginRight: 6 }}>⚡</span>{eventText ?? '—'}
      </div>
      <div data-testid="info-speech" style={{ ...line, color: subtitles.length ? '#e8eefc' : '#5d6b88' }}>
        <span aria-hidden style={{ marginRight: 6 }}>💬</span>
        {subtitles.length ? subtitles.map((sub, i) => (
          <span key={sub.id}>{i ? ' / ' : ''}<span style={{ color: '#ffd36b', fontSize: 11, fontWeight: 700, marginRight: 4 }}>{sub.speaker}</span>{sub.text}</span>
        )) : '—'}
      </div>
    </div>
  );
}
